import { useMemo } from "react"

export const useReactedSuggestions = ({ guestReactions, guestSuggestions }) => {
  return useMemo(() => {
    const suggestionsIds = new Set(Object.keys(guestReactions).map(Number))

    return guestSuggestions.filter(event => suggestionsIds.has(event.id))
  }, [guestReactions, guestSuggestions])
}
